/* eslint-disable react/no-unescaped-entities */
import { LIST_TYPE } from "@/shared/types/atoms.types";
import Link from "next/link";
import React from "react";
import ListSection from "../atoms/ListSection";
import TermsParagraph from "../atoms/TermsParagraph";

export const marketingListData = [
  {
    index: "(a)",
    description: "not advertise Graphy as a free product.",
  },
  {
    index: "(b)",
    description:
      "not make any false, misleading, or disparaging statements with respect to the Graphy, its employees, its customers, its Affiliates, its Services (as defined under the Platform Terms), or the Affiliate Program.",
  },
  {
    index: "(c)",
    description:
      "not use traffic that is generated by, including, but not limited to, pay to click, pay to read, banner exchanges, click exchanges, cost-per-view advertising, pop-up/under, spam, purchased traffic, or similar methods without prior written consent from Graphy.",
  },
  {
    index: "(d)",
    description:
      "not use cookie stuffing techniques that set the tracking cookie without the potential customer actually clicking on the Affiliate’s Referral Link.",
  },
  {
    index: "(e)",
    description:
      "be responsible for ensuring their tracking codes are working properly before sending traffic to Graphy’s servers. Any modification to the Referral Links is the sole responsibility of the Affiliate. Referral Rewards may be withheld, at Graphy’s sole discretion, for tracking errors caused by editing, masking, redirecting or tampering with Referral Links.",
  },
  {
    index: "(f)",
    description:
      "not create websites or advertisements that copy, imitate, or resemble the look and feel of Graphy’s Services.",
  },
  {
    index: "(g)",
    description:
      "not engage in domain forwarding (i.e., purchasing a domain and setting it to forward directly to Graphy’s website using a Referral Link).",
  },
  {
    index: "(h)",
    description:
      "not engage in the advertisement of business-opportunity websites or use marketing practices that attract fraudulent or short-term customers.",
  },
  {
    index: "(i)",
    description:
      "not engage in any marketing activity that may harm the reputation or credibility of Graphy, including but not limited to using low-quality marketing materials, or advertising on any website that promotes violence, discrimination based on race, sex, religion, nationality, disability, sexual orientation or age, or any illegal activities, or violates the intellectual property or other rights of a third party.",
  },
  {
    index: "(j)",
    description:
      "include a physical mailing address and unsubscribe information for any marketing email sent promoting Graphy’s Services.",
  },
  {
    index: "(k)",
    description:
      "communicate clearly that they, not Graphy, are the sender of all marketing communications related to the promotion of Graphy’s Services as part of the Affiliate Program.",
  },
  {
    index: "(l)",
    description:
      "not engage in any marketing or promotional activities that violate applicable laws, rules, or regulations.",
  },
  {
    index: "(m)",
    description:
      "not market using facsimile, broadcast, telemarketing, text message marketing, or other offline marketing methods regarding Graphy and/or its Services without the express written consent of Graphy.",
  },
  {
    index: "(n)",
    description:
      "not use malware or spyware to market or promote Graphy’s Services.",
  },
];

interface MarketingListProps {}

const MarketingList: React.FC<MarketingListProps> = () => {
  return (
    <div>
      <ListSection
        listIndex="3.1."
        description="You shall bear Your own costs and expenses related to marketing and promoting Graphy. Graphy is not obligated to reimburse or credit You for any marketing expenses, unless it has been specifically agreed by Graphy in writing (emails included). "
        listType={LIST_TYPE.LIST2}
      />

      <ListSection
        listIndex="3.2."
        listType={LIST_TYPE.LIST2}
        description="You hereby represent and warrant that Your marketing practices do not violate any of the following restrictions. Affiliates shall -"
      />
      {marketingListData.map((data) => (
        <React.Fragment key={data.index}>
          <ListSection
            listIndex={data.index}
            listType={LIST_TYPE.LIST3}
            description={data.description}
          />
        </React.Fragment>
      ))}

      <ListSection
        listIndex="3.3."
        title="Coupons and Promotional Codes:"
        listType={LIST_TYPE.LIST2}
        description="Affiliates may only use coupons and promotional codes that are provided exclusively through the Affiliate Program. We do not provide any rewards or incentives to Referred Users, and Graphy reserves the right to cancel any and all Referral Rewards where it finds evidence of any activity run by You that claims or otherwise communicates offering of rewards or incentives to Referred Users by Graphy. Further, we do not encourage offering such incentives or rewards by Affiliates to promote the use of their Referral Links in any manner."
      />

      <ListSection
        listIndex="3.4."
        title="Prohibited Activities:"
        listType={LIST_TYPE.LIST2}
      />

      <ListSection
        listIndex="(a)"
        listType={LIST_TYPE.LIST3}
        description="Except as permitted herein, You shall not and are not authorized to –"
      />

      <ListSection
        listIndex="(i)"
        listType={LIST_TYPE.LIST4}
        description={
          <TermsParagraph>
            use Graphy’s trademark or other intellectual property, including
            without limitation, the Referral Links (collectively,{" "}
            <b>“Graphy’s Intellectual Property” or “Graphy’s IP”</b>) without
            Graphy’s express prior written permission;
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(ii)"
        listType={LIST_TYPE.LIST4}
        description="use Graphy’s name (or any variation or misspelling thereof or other terms that are confusingly similar to any of the foregoing) in a domain name, any metatags, advertising, search terms, code, or otherwise; or"
      />

      <ListSection
        listIndex="(iii)"
        listType={LIST_TYPE.LIST4}
        description="act in any way that causes or could cause any confusion concerning the source of, or Your association with Graphy’s Services. Your use of Graphy’s IP in any manner, other than as expressly permitted hereunder and/or as communicated to You by Graphy in writing (emails included) shall constitute unlawful infringement of Graphy’s IP rights and Graphy shall have the right to enforce its rights against You which may subject You to liabilities including without limitation to pay Graphy’s legal fees and costs."
      />

      <ListSection
        listIndex="(b)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            You are prohibited from bidding on any Graphy trademarks, or any
            variations and misspellings thereof.{" "}
            <b className="underline">Examples</b> of prohibited keywords are
            “Graphy”, “Gra-phy”, “Graphyapp”, “Graphy.com”, “Graphy.in”,
            “Graphyapp.co”, “india.Graphy.com," “Graphy hosting”, “Graphy
            domains”.
          </TermsParagraph>
        }
      />

      <ListSection
        listIndex="(c)"
        listType={LIST_TYPE.LIST3}
        description="You are prohibited from bidding on keywords containing Graphy trademarks plus an additional term such as [Graphy coupons], [Graphy promotions], and [Graphy promos]. Further, Affiliates are NOT permitted to broad or phrase match any of these keywords."
      />

      <ListSection
        listIndex="(d)"
        listType={LIST_TYPE.LIST3}
        description="You are prohibited from outranking Graphy's internal paid search ad on any keywords."
      />

      <ListSection
        listIndex="(e)"
        listType={LIST_TYPE.LIST3}
        description="You are prohibited from direct linking to the Platform from any paid search ads."
      />

      <ListSection
        listIndex="(f)"
        listType={LIST_TYPE.LIST3}
        description={
          <TermsParagraph>
            You are prohibited from using{" "}
            <Link href="/store">www.graphy.com</Link> as a display URL.
          </TermsParagraph>
        }
      />

      <TermsParagraph className="ml-4 md:ml-16">
        If You are determined to be in violation of this section Your
        participation in the Affiliate Program may be terminated. For more
        information on match types, please visit Google's overview of{" "}
        <a
          href="https://support.google.com/google-ads/answer/7478529?hl=en&visit_id=637175332283452149-3617255890&rd=1"
          target="_blank"
        >
          match types
        </a>
        .
      </TermsParagraph>
    </div>
  );
};

MarketingList.displayName = "MarketingList";

export default MarketingList;
